import { render, staticRenderFns } from "./LogoSVG.vue?vue&type=template&id=6df10c99&scoped=true&name=component-name&"
import script from "./LogoSVG.vue?vue&type=script&lang=js&"
export * from "./LogoSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df10c99",
  null
  
)

export default component.exports